module.exports = __webpack_public_path__ + "img/email.a43c43d0.svg";